import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropbox-brands",
  "use": "dropbox-brands-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dropbox-brands\"><path d=\"M12.018 5.65l-6 3.832 6 3.832-6 3.831L0 13.277l6.014-3.832L0 5.65l6.014-3.832 6.004 3.832zm-6.036 12.7l6-3.832 6 3.832-6 3.832-6-3.832zm6.036-5.073l6-3.832-6-3.8 5.968-3.827L24 5.65l-6.014 3.832L24 13.309l-6.014 3.832-5.968-3.864z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol